export default "__VITE_ASSET__ZqQgtth___"